import { ChangeEvent, useEffect, useState } from 'react'

import { SelectRebrand } from 'src/components/atoms/SelectRebrand'
import { ParagraphNoSpace } from 'src/components/atoms/Typography'
import { PaginationRebrand } from 'src/components/molecules/PaginationRebrand'
import { RegistryCardRebrand } from 'src/components/molecules/RegistryCardRebrand'

import { listRegistriesPath, viewRegistryPath } from 'src/config/paths'
import { env } from 'src/env/client.mjs'
import { usePagination } from 'src/hooks/usePagination'
import { trpc } from 'src/utils/trpc'

const PAGE_SIZE = 9

const SORT_OPTIONS = [
  { label: 'Most recent', value: 'CreatedOn' },
  { label: 'Registry name (A-Z)', value: 'Name' },
  { label: 'Closing soon', value: 'ClosesOn' }
]

type OrderBy = 'CreatedOn' | 'Name' | 'ClosesOn'

const RegistriesSectionRebrand = () => {
  const [orderBy, setOrderBy] = useState<OrderBy>('CreatedOn')

  const { currentPage, offset, onPageClick, resetPagination } = usePagination({
    limit: PAGE_SIZE
  })

  const [queryVariables, setQueryVariables] = useState<{
    offset: number
    limit: number
    orderBy: OrderBy
  }>({ offset: 0, limit: PAGE_SIZE, orderBy })

  useEffect(() => {
    setQueryVariables({ offset, limit: PAGE_SIZE, orderBy })
  }, [offset, orderBy])

  const { data, isLoading } = trpc.useQuery(['registries.all', queryVariables])

  return (
    <div className='container mx-auto px-4 lg:px-20'>
      <div className='flex flex-col gap-10'>
        <div className='flex flex-col md:flex-row md:items-center md:justify-between gap-5'>
          <ParagraphNoSpace className='text-[20px]! m-0! font-bold'>
            {isLoading
              ? ' '
              : `${data?.count ?? 0} tree registries currently active`}
          </ParagraphNoSpace>
          <SelectRebrand
            id='sort'
            className='w-full md:w-[268px] bg-white!'
            options={SORT_OPTIONS}
            onChange={(e: ChangeEvent<HTMLSelectElement>) => {
              resetPagination()
              setOrderBy(e.target.value as OrderBy)
            }}
            value={orderBy}
          />
        </div>

        {!isLoading &&
          (data?.registries?.length ? (
            <>
              <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5'>
                {data.registries.map(registry => (
                  <RegistryCardRebrand
                    key={registry.Id}
                    name={registry.Name ?? ''}
                    href={
                      registry.Uri
                        ? viewRegistryPath({
                            routeParams: { registryUri: registry.Uri }
                          })
                        : listRegistriesPath
                    }
                    imageUrl={
                      registry.Hero
                        ? `${env.NEXT_PUBLIC_ASSETS_DOMAIN}/${registry.Hero}`
                        : undefined
                    }
                    trees={registry.Trees ?? 0}
                    gifts={registry.Gifts ?? 0}
                    closesOn={registry.ClosesOn}
                  />
                ))}
              </div>
              <div className='flex justify-center'>
                <PaginationRebrand
                  count={data?.count || 0}
                  onChange={(page: number) => onPageClick(page)}
                  page={currentPage}
                  pageSize={PAGE_SIZE}
                />
              </div>
            </>
          ) : (
            <div>We could not find any tree registries</div>
          ))}
      </div>
    </div>
  )
}

export default RegistriesSectionRebrand
